import { render, staticRenderFns } from "./FacebookAuthButton.vue?vue&type=template&id=5281ccbe&scoped=true&"
import script from "./FacebookAuthButton.vue?vue&type=script&lang=js&"
export * from "./FacebookAuthButton.vue?vue&type=script&lang=js&"
import style0 from "./FacebookAuthButton.vue?vue&type=style&index=0&id=5281ccbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5281ccbe",
  null
  
)

export default component.exports